<div class="mb-order-history-wrapper"
     *ngIf="orders$ | async as orderHistory">
  <div class="container">
    <div class="mb-order-history-body">
      <span class="mb-order-history-title">{{ 'mbMyAccount.ordersAndRequests' | cxTranslate }}</span>
      <ng-container *ngIf="orderHistory.pagination?.totalResults > 0; else noOrder">
        <div class="mb-order-history-top row">
          <div class="mb-order-history-form-group form-group col-sm-12 col-md-4 col-lg-4">
              <span class="mb-order-history-sort-label">
                {{ 'orderHistory.sortBy' | cxTranslate }}
              </span>
            <cx-sorting [sortOptions]="orderHistory.sorts"
                        [sortLabels]="getSortLabels() | async"
                        (sortListEvent)="changeSortCode($event)"
                        [selectedOption]="orderHistory.pagination.sort"
                        placeholder="{{ 'orderHistory.sortBy' | cxTranslate }}">
            </cx-sorting>
          </div>
          <div class="mb-order-history-top-row-placeholder col-sm-12 col-md-4 col-lg-4"></div>
          <div *ngIf="orderHistory.pagination?.totalPages > 1"
               class="cx-order-history-pagination col-sm-12 col-md-4 col-lg-4 ">
            <cx-pagination [pagination]="orderHistory.pagination"
                           (viewPageEvent)="pageChange($event)">
            </cx-pagination>
          </div>
        </div>

        <table class="table cx-order-history-table">
          <thead class="cx-order-history-thead-mobile">
          <th scope="col">
            {{ 'orderHistory.orderId' | cxTranslate }}
          </th>
          <th scope="col" class="hidden-xs hidden-sm">{{ 'orderHistory.date' | cxTranslate }}</th>
          <th scope="col" class="hidden-xs hidden-sm">{{ 'mbMyAccount.orderHistory.orderType' | cxTranslate }}</th>
          <th scope="col" class="hidden-xs hidden-sm">
            {{ 'orderHistory.status' | cxTranslate }}
          </th>
          <th scope="col" class="text-right">{{ 'orderHistory.total' | cxTranslate }}</th>
          </thead>

          <tbody>
          <tr *ngFor="let order of orderHistory.orders"
              (click)="goToOrderDetail(order)"
              class="cursor-pointer">
            <td class="cx-order-history-code">
              <a [routerLink]="{ cxRoute: 'mbOrderDetails', params: order } | cxUrl"
                 class="cx-order-history-value">
                {{ order?.code }}
              </a>
              <div class="d-md-none row no-gutters cx-order-history-label">
                <div class="col-4 mb-order-history-labels">{{ 'orderHistory.date' | cxTranslate }}</div>
                <div class="col-8">{{ order?.placed | cxDate: 'MM/dd/yyyy' }}</div>
                <div class="col-4 mb-order-history-labels">{{ 'mbMyAccount.orderHistory.orderType' | cxTranslate }}</div>
                <div class="col-8">
                  <span *ngIf="order?.orderType === orderType.ORDER" class="pr-2">{{'mbcart.purchase' | cxTranslate}}</span>
                  <span *ngIf="order?.orderType === orderType.REQUEST" class="pr-2">{{'mbcart.request' | cxTranslate}}</span>
                  <span *ngIf="order?.orderType === orderType.MIXED" class="pr-2">{{'mbMyAccount.orderHistory.mixedOrder' | cxTranslate}}</span>
                </div>
                <div class="col-4 mb-order-history-labels">{{ 'orderHistory.status' | cxTranslate }}</div>
                <div class="col-8">{{order?.statusDisplay}}</div>
              </div>
            </td>
            <td class="hidden-xs hidden-sm cx-order-history-placed">
              {{ order?.placed | cxDate: 'MM/dd/yyyy' }}
            </td>
            <td class="hidden-xs hidden-sm cx-order-history-orderType">
              <div class="cx-order-history-label">
                  <span *ngIf="order?.orderType === orderType.ORDER || order?.orderType === orderType.MIXED" class="pr-2">
                     <img alt="purchase"
                          data-icon="purchase"
                          src="../../assets/icons/svg/Icon_cart.svg"
                          class="mb-icon-size"
                          title="purchase">
                  </span>
                <span *ngIf="order?.orderType === orderType.REQUEST || order?.orderType === orderType.MIXED">
                     <img alt="request"
                          data-icon="request"
                          src="../../../assets/icons/svg/icon_request_items.svg"
                          class="mb-icon-size"
                          title="request">
                  </span>
              </div>
            </td>
            <td class="hidden-xs hidden-sm cx-order-history-status">
              {{order?.statusDisplay}}
            </td>
            <td class="cx-order-history-total text-right">
              <span
                *ngIf="!order?.erpPricingError && order?.erpTotal?.formattedValue"> {{ order?.erpTotal?.formattedValue }}</span>
              <span
                *ngIf="!order?.erpPricingError && !order?.erpTotal?.formattedValue"> {{ 'mbcommon.priceOnRequest' | cxTranslate }}</span>
              <span *ngIf="order?.erpPricingError"> {{ 'submitBox.orderConfirmation' | cxTranslate }}</span>
            </td>
          </tr>
          </tbody>
        </table>
      </ng-container>

      <!-- NO ORDER CONTAINER -->
      <ng-template #noOrder>
        <div *ngIf="isLoaded$ | async"
             class="cx-order-history-no-order">
          <ng-container *ngIf="orderHistory">
            <mb-myaccount-no-data-card
              [message]="'mbMyAccount.orderHistory.noOrders.message' | cxTranslate"
              [link]="'/'"
              [linkText]="'mbMyAccount.orderHistory.noOrders.linkText' | cxTranslate">
            </mb-myaccount-no-data-card>
          </ng-container>
        </div>
      </ng-template>
    </div>
    <mb-myaccount-button [path]="'myAccount'"
                         [textTranslationPath]="'mbMyAccount.backToMyAccount'">
    </mb-myaccount-button>
  </div>
</div>
<mb-myaccount-mobile-navigation></mb-myaccount-mobile-navigation>
